import { MfaChallenge } from '../../../../interfaces/MfaChallenge';

export default function transformFactorsRequest(
  emailChallenge: MfaChallenge,
  smsChallenge: MfaChallenge,
) {
  return {
    phoneNumber: smsChallenge?.display,
    phoneNumberHashToken: smsChallenge?.hashToken,
    emailAddress: emailChallenge?.display,
    emailAddressHashToken: emailChallenge?.hashToken,
  };
}
